import { render, staticRenderFns } from "./ApprovalsSubmitNotification.vue?vue&type=template&id=2a23cae5&scoped=true"
import script from "./ApprovalsSubmitNotification.vue?vue&type=script&lang=js"
export * from "./ApprovalsSubmitNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a23cae5",
  null
  
)

export default component.exports